import News from "@/views/news/News.vue";
import Article from "@/views/news/Article.vue";
import Datasets from "@/views/dataset/Datasets.vue";
import DatasetWizard from "@/views/dataset/DatasetWizard.vue";
import Dataset from "@/views/dataset/Dataset.vue";
import Search from "@/views/dataset/Search.vue";
import Document from "@/views/dataset/Document.vue";
import Dashboards from "@/views/dashboard/Dashboards.vue";
import Dashboard from "@/views/dashboard/Dashboard.vue";
import Profile from "@/views/account/Profile.vue";
import TwitterCallback from "@/views/account/TwitterCallback.vue";
import Support from "@/views/Support.vue";
import Accounts from "@/views/admin/Accounts.vue";
import Users from "@/views/admin/Users.vue";
import Sources from "@/views/admin/Sources.vue";
import Status from "@/views/admin/Status.vue";


import PrincipalesHechos from "@/views/dashboard/custom/PrincipalesHechos.vue";
import Defensoria1 from "@/views/dashboard/custom/Defensoria1.vue";
import Defensoria2 from "@/views/dashboard/custom/Defensoria2.vue";
import Tutelas from "@/views/dashboard/custom/Tutelas.vue";
import Showcase from "@/views/Showcase.vue";


const routes = [
    {
        path: "/news",
        name: "News",
        component: News
    },
    {
        path: "/news/:uid",
        name: "Article",
        component: Article
    },
    {
        path: "/datasets",
        name: "Datasets",
        component: Datasets
    },
    {
        path: "/datasets/wizard",
        name: "DatasetsWizard",
        component: DatasetWizard
    },
    {
        path: "/datasets/:datasetUid",
        name: "Dataset",
        component: Dataset
    },
    {
        path: "/datasets/:datasetUid/search",
        name: "Search",
        component: Search
    },
    {
        path: "/datasets/:datasetUid/document/:documentUid",
        name: "Document",
        component: Document
    },
    {
        path: "/dashboards",
        name: "Dashboards",
        component: Dashboards
    },
    {
        path: "/dashboard/:dashboardId?",
        name: "Dashboard",
        component: Dashboard
    },
    {
        path: "/profile",
        name: "Profile",
        component: Profile
    },
    {
        path: "/twitter/ok",
        name: "TwitterCallback",
        component: TwitterCallback
    },

    {
        path: "/admin/users",
        name: "Users",
        component: Users
    },
    {
        path: "/admin/sources",
        name: "Sources",
        component: Sources
    },
    {
        path: "/admin/status",
        name: "Status",
        component: Status
    },
    {
        path: "/admin/accounts",
        name: "Accounts",
        component: Accounts
    },
    {
        path: "/support",
        name: "Support",
        component: Support
    },
    {
        path: "/showcase",
        name: "Showcase",
        component: Showcase
    },
    {
        path: "/hechos/search",
        name: "PrincipalesHechos",
        component: PrincipalesHechos
    },
    {
        path: "/delegadas/search",
        name: "Defensoria1",
        component: Defensoria1
    },
    {
        path: "/etnicos/search",
        name: "Defensoria2",
        component: Defensoria2
    },
    {
        path: "/tutelas",
        name: "Tutelas",
        component: Tutelas
    }

];

export default routes.map(route => {
    const meta = {
        ...route.meta || {},
        requiresAuth: true
    }
    return { ...route, meta }
});